/* eslint-disable no-undef */
import { Helmet } from 'react-helmet';
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Check from '@zg-rentals/multibrand-ui/lib/icons/Check';
import Center from '@zg-rentals/multibrand-ui/lib/Center';
import Section from '@zg-rentals/multibrand-ui/lib/Section';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Link from '@zg-rentals/multibrand-ui/lib/Link';
import Container from '@zg-rentals/multibrand-ui/lib/Container';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import Col from '@zg-rentals/multibrand-ui/lib/Col';

import queryUtil from '../../../utils/queryUtils';
import sharedConfig from '../../../sharedConfig';
import pathsManifest from '../../../pathsManifest';

const iconSizes = {
  hotpads: '24',
  trulia: '42',
  zillow: '42',
};

class TourFeedbackSuccessPage extends React.Component {
  generateReviewLinks() {
    const { titles, providerListingIds } = this.props.currentQuery;
    const reviewLinks = [];
    const reviewIds = decodeURIComponent(providerListingIds).split(',');
    const reviewTitles = decodeURIComponent(titles).split(',');

    reviewIds.forEach((id, i) => {
      if (id !== '' && reviewTitles[i] !== '') {
        const link = `${pathsManifest.propertyRatingAndReviewRatePage}?providerListingId=${id}&reviewerType=FUTURE_RESIDENT`;

        reviewLinks.push(
          <div key={id}>
            <Button type="primary" onClick={() => window.open(link)}>
              Leave a review for {reviewTitles[i]}
            </Button>
          </div>,
        );
      }
    });

    return reviewLinks;
  }
  render() {
    const { brand, currentQuery } = this.props;
    const { providerListingIds } = currentQuery;

    const title = 'Thanks for the update!';
    const description = providerListingIds
      ? 'If you have a minute, would you also like to leave a review?'
      : 'Your feedback helps us improve your experience.';
    const linkbackText = providerListingIds ? 'No thanks. Search for homes.' : 'Search for homes.';

    let homeLink = '/';
    if (brand === sharedConfig.brands.zillow) {
      homeLink = '/renting';
    }

    return (
      <div className="TourFeedbackSuccessPage">
        <Helmet>
          <meta name="robots" content="noindex" />
          <title>Thank You!</title>
        </Helmet>
        <Container>
          <Section>
            <Center>
              <Check colorType="success" size={iconSizes[brand]} />

              <div className="stacked-lg">
                <Text type="h3">{title}</Text>
              </div>
              <div className="stacked-lg">
                <Text type="body">{description}</Text>
              </div>
            </Center>

            <Row>
              <Col>
                <Center>
                  {providerListingIds && <div className="stacked-children-lg">{this.generateReviewLinks()}</div>}

                  <Link type="secondary" href={homeLink}>
                    {linkbackText}
                  </Link>
                </Center>
              </Col>
            </Row>
          </Section>
        </Container>
      </div>
    );
  }
}

TourFeedbackSuccessPage.propTypes = {
  currentQuery: PropTypes.object,
  brand: PropTypes.string,
};

const mapStateToProps = (state) => ({
  currentQuery: queryUtil.parse(state.router.location.search),
  brand: state.app.brand,
  currentArea: state.area.currentArea,
});

export default connect(mapStateToProps)(TourFeedbackSuccessPage);
